import { BitmapText } from '@inlet/react-pixi'
import React from "react";


interface IProps {
    [x: string]: any;

    // loader: {
    //     config: {string:string}
    // }
}

interface IState {
    textElement: any
}

class UIBitmapText extends React.Component<IProps, IState> {


    protected textObj: any;

    constructor(props: IProps) {
        super(props);

        this.textObj = {};
        // this.Layer = props.Layers[props.uiDetails.parentLayer || "baseLayer"];
    }


    componentDidMount() {

        this.createtext();
        this.addText();

        var measuredWidth = 0;
        if (this.props.scaleToFit === true && this.props.width > 0) {
            measuredWidth = this.textObj.getLocalBounds().width;
            while (measuredWidth > this.props.width) {

                let newStyle = this.textObj.style;
                newStyle.fontSize -= 1;
                // this.textObj.textStyle = newStyle;
                this.textObj.fontSize = newStyle.fontSize;
                measuredWidth = this.textObj.getLocalBounds().width;
                if (newStyle.fontSize === this.textObj.minFontSize) {
                    break;
                }
            }
        }
    }


    addText() {

    }

    createtext() {
        this.textObj.propsdata = this.props
    }

    componentWillUnmount() {

    }


    render() {
        return (<BitmapText ref={i => {
            this.props.addRef(this.props.name || this.props.id, i);
            return this.textObj = i;
        }} text={this.props.langObj[this.props.text] || this.props.text}
            style={this.props.textStyle}
            anchor={this.props.anchor || [0.5, 0.5]} x={this.props.x}
            y={this.props.y}></BitmapText>)
    }

}

//export default withPixiApp(withButtonPanelConfiguration(ButtonStaticImage));
export default UIBitmapText;